import { MediaPipelineStage } from '@roadfootage/api-client'

/** Staff-facing names for the media pipeline stages, shared by the file detail and the dashboard. */
export const STEP_LABELS: Record<MediaPipelineStage, string> = {
  [MediaPipelineStage.Queued]: 'Queued',
  [MediaPipelineStage.Download]: 'Download',
  [MediaPipelineStage.VirusScan]: 'Virus scan',
  [MediaPipelineStage.Mezzanine]: 'Mezzanine',
  [MediaPipelineStage.Thumbnail]: 'Thumbnail',
  [MediaPipelineStage.Playback]: 'Playback',
  [MediaPipelineStage.HoverPreview]: 'Hover preview'
}
